import { useEffect } from 'react';

const useTheme = (theme: string) => {
  useEffect(() => {
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }

    return () => document.body.classList.remove(`theme-${theme}`);
  }, [theme]);
};

export { useTheme };
